var _DRAG_EVENT_TO_STATE_;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import gettext from 'js-utils/gettext';
import UploaderDropzone from './UploaderDropzone';
import { isPromise, getActiveUploaderElementType, getActiveDropzoneElement } from './utils';
import { DRAG_START_EVENT, DRAG_END_EVENT, WINDOW_DRAG_START_EVENT, WINDOW_DRAG_END_EVENT, PREVIEW_ELEMENT_TYPE, LOADING_ELEMENT_TYPE, DROPZONE_ELEMENT_TYPE } from './constants';
import { hasDragAndDropFile } from '../utils/dom';
import NotificationBar from '../notification/NotificationBar';
import { TYPE_ERROR } from '../notification/constants';
var DRAG_EVENT_TO_STATE_MAP = (_DRAG_EVENT_TO_STATE_ = {}, _defineProperty(_DRAG_EVENT_TO_STATE_, DRAG_START_EVENT, {
  isDraggedOver: true
}), _defineProperty(_DRAG_EVENT_TO_STATE_, DRAG_END_EVENT, {
  isDraggedOver: false
}), _defineProperty(_DRAG_EVENT_TO_STATE_, WINDOW_DRAG_START_EVENT, {
  windowDraggedOver: true
}), _defineProperty(_DRAG_EVENT_TO_STATE_, WINDOW_DRAG_END_EVENT, {
  windowDraggedOver: false
}), _DRAG_EVENT_TO_STATE_);
/**
 * Markup that's shown to user by default if their browser
 * doesn't support drag-drop to upload
 */

var defaultUnsupportedFallback = React.createElement("div", null, gettext('Uploading not supported'));
/**
 * Markup for error message (if one is provided)
 */

var ErrorMessage = function ErrorMessage(_ref) {
  var message = _ref.message;
  return React.createElement("div", {
    className: "eds-l-mar-bot-3"
  }, React.createElement(NotificationBar, {
    type: TYPE_ERROR
  }, message));
};
/**
 * A utility that manages uploader presentation based on current
 * state.  This includes state of user interaction and state of
 * persisted resources.
 * @extends React.PureComponent
 * @example
 * // <UploaderLayoutManager
 * //     onReceiveFile={uploadFunction}
 * //     dropzoneElement={<MyDropzone />}
 * //     dragDropzoneElement={<MyDraggedDropzone />}
 * //     loadingElement={<MyLoadingLayout />}
 * //     previewElement={<MyPreviewLayout />}
 * // />
 */


var UploaderLayoutManager =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(UploaderLayoutManager, _React$PureComponent);

  function UploaderLayoutManager() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, UploaderLayoutManager);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(UploaderLayoutManager)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      isDraggedOver: false,
      windowDraggedOver: false,
      isLoading: false
    });

    return _this;
  }

  _createClass(UploaderLayoutManager, [{
    key: "_handleDragEvent",
    value: function _handleDragEvent(eventType) {
      var stateChange = DRAG_EVENT_TO_STATE_MAP[eventType];

      if (stateChange) {
        this.setState(stateChange);
      }
    }
  }, {
    key: "_handleFileDrop",
    value: function _handleFileDrop(file) {
      var _this2 = this;

      var onReceiveFile = this.props.onReceiveFile;

      var finishLoading = function finishLoading() {
        return _this2.setState({
          isLoading: false
        });
      };

      this.setState({
        isLoading: true,
        isDraggedOver: false,
        windowDraggedOver: false
      });
      var promise = onReceiveFile(file);

      if (!isPromise(promise)) {
        throw new Error('onReceiveFile prop should return a promise');
      }

      promise.then(finishLoading).catch(finishLoading);
    }
  }, {
    key: "_getCurrentElement",
    value: function _getCurrentElement() {
      var _elementMap;

      var _this$props = this.props,
          dropzoneElement = _this$props.dropzoneElement,
          dragDropzoneElement = _this$props.dragDropzoneElement,
          windowDragDropzoneElement = _this$props.windowDragDropzoneElement,
          previewElement = _this$props.previewElement,
          showPreview = _this$props.showPreview,
          loadingElement = _this$props.loadingElement;
      var _this$state = this.state,
          isLoading = _this$state.isLoading,
          isDraggedOver = _this$state.isDraggedOver,
          windowDraggedOver = _this$state.windowDraggedOver;
      var dropzoneContent = getActiveDropzoneElement(isDraggedOver, windowDraggedOver, dropzoneElement, dragDropzoneElement, windowDragDropzoneElement);
      var elementMap = (_elementMap = {}, _defineProperty(_elementMap, PREVIEW_ELEMENT_TYPE, previewElement), _defineProperty(_elementMap, LOADING_ELEMENT_TYPE, loadingElement), _defineProperty(_elementMap, DROPZONE_ELEMENT_TYPE, React.createElement(UploaderDropzone, {
        onDragEvent: this._handleDragEvent.bind(this),
        onFileDrop: this._handleFileDrop.bind(this)
      }, dropzoneContent)), _elementMap);
      var elementType = getActiveUploaderElementType(showPreview, isLoading);
      return elementMap[elementType];
    }
  }, {
    key: "render",
    value: function render() {
      if (!hasDragAndDropFile()) {
        var unsupportedFallback = this.props.unsupportedFallback;
        return unsupportedFallback;
      }

      var errorContent = this.props.errorContent;
      var errorDisplay = null;

      if (errorContent) {
        errorDisplay = React.createElement(ErrorMessage, {
          message: errorContent
        });
      }

      var currentElement = this._getCurrentElement();

      return React.createElement("div", null, errorDisplay, currentElement);
    }
  }]);

  return UploaderLayoutManager;
}(React.PureComponent);

_defineProperty(UploaderLayoutManager, "propTypes", {
  /**
   * Function that's invoked when the user has chosen a file
   */
  onReceiveFile: PropTypes.func.isRequired,

  /**
   * The element that's shown to users when the uploader has
   * no existing file selected and is not having a file dragged
   * over.  This is the initial uploader state.
   */
  dropzoneElement: PropTypes.element.isRequired,

  /**
   * The element that's shown to users when they drag
   * a file over the dropzone.
   */
  dragDropzoneElement: PropTypes.element.isRequired,

  /**
   * The element that's shown to users after they've dropped
   * a file while it is being transported/saved.
   */
  loadingElement: PropTypes.element.isRequired,

  /**
   * The element that's shown to users after a file has been
   * successfully uploaded and persisted.  This is used
   * while the uploader is populated.
   */
  previewElement: PropTypes.element.isRequired,

  /**
   * The element that's shown to users after a file has been
   * dragged over the window, but not yet over the dropzone.
   * This acts as a call-to-action, showing the user where
   * they can drop their file.  If this prop is omitted,
   * the regular dragDropzoneElement is used.
   */
  windowDragDropzoneElement: PropTypes.element,

  /**
   * The consumer must inform the layoutManager if it has
   * the correct data necessary to show a preview of the
   * populated file.
   */
  showPreview: PropTypes.bool,

  /**
   * Any error message the consumer may need to display.
   * This will most often be used to show transport failures
   * (ajax failed, etc) and validation errors (incorrect
   * file types, filesize too large, etc)
   */
  errorContent: PropTypes.node,

  /**
   * This is the component shown to user if their browser
   * doesn't have the correct capabilities to handle
   * drag-drop to upload.
   */
  unsupportedFallback: PropTypes.element
});

_defineProperty(UploaderLayoutManager, "defaultProps", {
  showPreview: false,
  unsupportedFallback: defaultUnsupportedFallback
});

export { UploaderLayoutManager as default };